import Vue from 'vue'
import Router from 'vue-router'
// import Codes from './views/Codes.vue'
import Home from './views/Home.vue'
import Kontakt from './views/Kontakt.vue'
import Impressum from './views/Impressum.vue'
import Datenschutz from './views/Datenschutz.vue'
import Termin from './views/Termine.vue'
import Team from './views/Team.vue'

import firebase from 'firebase'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/team',
      name: 'team',
      component: Team,
      meta: {
        requiresAuth: false
      }

  },

    {
      path: '/termine',
      name: 'termin',
      component: Termin,
      meta: {
        requiresAuth: false
      },
    },
    {
      path: '/kontakt',
      name: 'kontakt',
      component: Kontakt,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/impressum',
      name: 'impressum',
      component: Impressum,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/datenschutz',
      name: 'datenschutz',
      component: Datenschutz,
      meta: {
        requiresAuth: false
      }
    }


  ],
scrollBehavior (to, from, savedPosition) {
    //https://router.vuejs.org/guide/advanced/scroll-behavior.html
    if (to.hash) {
            return { selector: to.hash }
        } else if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 }
        }
  }
}


)

// Guards

router.beforeEach((to, from, next ) => {
  // check fro required Atuh guard
  if(to.matched.some(record => record.meta.requiresAuth)) {
    // Check if not logged in
    if(!firebase.auth().currentUser){
      next({
        path:'/login',
        query:{
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    // Check if not logged in
    if(firebase.auth().currentUser){
      next({
        path:'/',
        query:{
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }

})

export default router
